var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCircleInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.0332031C3.5625 0.0332031 0 3.62695 0 8.0332C0 12.4707 3.5625 16.0332 8 16.0332C12.4062 16.0332 16 12.4707 16 8.0332C16 3.62695 12.4062 0.0332031 8 0.0332031ZM8 4.0332C8.53125 4.0332 9 4.50195 9 5.0332C9 5.5957 8.53125 6.0332 8 6.0332C7.4375 6.0332 7 5.5957 7 5.0332C7 4.50195 7.4375 4.0332 8 4.0332ZM9.25 12.0332H6.75C6.3125 12.0332 6 11.7207 6 11.2832C6 10.877 6.3125 10.5332 6.75 10.5332H7.25V8.5332H7C6.5625 8.5332 6.25 8.2207 6.25 7.7832C6.25 7.37695 6.5625 7.0332 7 7.0332H8C8.40625 7.0332 8.75 7.37695 8.75 7.7832V10.5332H9.25C9.65625 10.5332 10 10.877 10 11.2832C10 11.7207 9.65625 12.0332 9.25 12.0332Z",
    fill: "#FF2727"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-info.304c75e5.svg";
export { ForwardRef as ReactComponent };